try {
    window.Popper = require('popper.js').default;
    window.$ = window.jQuery = require('jquery');

    require('bootstrap');
    require('select2');
    require('./includes/jquery.sticky.min.js');
} catch (e) {}

jQuery(document).ready(function(){
    // $(document).find('#noes-multiple-files-form [type="file"]').on('input', function(event){
    //     $(this).parent().find('.holder_message').html($(this).val().split('\\').pop())
    // })
    // $('#signed_noe').on('input', function(event){
    //     $('.holder_message').html($(this).val().split('\\').pop())
    // })
    // ----------------------------------------
    // Init Select2
    // ----------------------------------------
    if($('.country').length) {
        $('.country').select2({
            // minimumResultsForSearch: Infinity,
            placeholder: "Select a country",
            allowClear: true
        });
    }

    if($('.system').length) {
        $('.system').not('#cu_clearing_system').select2({
            minimumResultsForSearch: Infinity,
            placeholder: "Select an option",
            allowClear: true
        });
    }

    // ----------------------------------------
    // Open User dropdown
    // ----------------------------------------
    $('.user--info').on('click', function(e) {
        e.preventDefault();
        $('.user--content').toggleClass('is--visible');
    })

    // ----------------------------------------
    // Scroll event
    // ----------------------------------------
    $(window).scroll(function() {
        var scroll = $(window).scrollTop();
        if (scroll >= 200) {
            $('.header__wrapper').addClass('shrink');
            $('header').addClass('shrink');
        } else {
            $('.header__wrapper').removeClass('shrink');
            $('header').removeClass('shrink');
        }
    });

    // ----------------------------------------
    // Sticky Elements
    // ----------------------------------------
    $("header").sticky({topSpacing:0});

    // ----------------------------------------
    // Fix Footer on bottom page
    // ----------------------------------------
    function fixfooter() {
        if(jQuery('footer').length > 0){
            var docHeight = jQuery(window).height();
            var footerHeight = jQuery('footer').innerHeight();
            var copyrightHeight = jQuery('.section__content--copyright').innerHeight();
            var footerTop = jQuery('footer').position().top + footerHeight + copyrightHeight;
            if (footerTop < docHeight) {
                jQuery('footer').css('margin-top', (docHeight - footerTop) + 'px');
            }
        }
    };
    if (jQuery(window).width() > 767) {
        fixfooter();
    };
    jQuery(window).resize(function() {
        fixfooter();
    });

});

$(document).ready(function(){

    $(document).on('change', '.has-nested', function (event) {
        console.log("click fired");
        enableVotingNestedInput($(this))
    });

    function enableVotingNestedInput(el) {
        disabledAllVotingNestedInput()
        $(el).parent().find('.is-nested').removeAttr("disabled")
        $(el).parent().find('.is-nested').attr("required", "")
    }

    function disabledAllVotingNestedInput() {
        $('.is-nested').attr("disabled", "")
        $('.is-nested').removeAttr("required")
    }

    enableNestedVoting()

    function enableNestedVoting() {
        $('.has-nested').each(function(){
            if($(this).is(':checked')){
                enableVotingNestedInput($(this))
            }
        })
    }

    $('.amount').on('input', function(){
        if($(this).val().length){
            $('*[data-cs-isin="' + $(this).data('isin') + '"]').attr("required", "")
        }else{
            $('*[data-cs-isin="' + $(this).data('isin') + '"]').removeAttr("required")
        }
    })

    $('#cu_account_number').on('keydown', function(e){
        // onKeyDown="if(this.value.length==6) return false;"
        let val = $(this).val()
        let len = val.length

        if((len === 7 && e.which != 8) || val < -1 || e.which === 38 || e.which === 40) {
            return false
        }
    })
})
